import { type LocalDB } from '../../LocalDB/LocalDB';
import { type FlightSupplementalData } from '../FlightSupplementalDataTypes';

export async function cleanupSupplementalData(db: LocalDB): Promise<void> {
    const toDelete = await db.flightSupplementalData.filter((i) => !itemIsUseful(i)).primaryKeys();
    if (toDelete.length) {
        await db.flightSupplementalData.bulkDelete(toDelete);
    }
}

export function itemIsUseful(item: FlightSupplementalData): boolean {
    return item.usefulnessEndsByDate.getTime() > Date.now();
}
